import { apiBaseUrl } from './runtime-config.mjs'

export function contextBase(pathname = '') {
  return pathname.match(/^\/c\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//)?.[0] || '/'
}

export function contextApiBase(location) {
  return apiBaseUrl(location)
}
